module.exports = __webpack_public_path__ + "img/1.3b253a00.jpeg";